import { render, staticRenderFns } from "./Opportunity.vue?vue&type=template&id=39e16593&scoped=true"
import script from "./Opportunity.vue?vue&type=script&lang=js"
export * from "./Opportunity.vue?vue&type=script&lang=js"
import style0 from "./Opportunity.vue?vue&type=style&index=0&id=39e16593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e16593",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/usr/src/app/components/Header.vue').default,Footer: require('/usr/src/app/components/Footer.vue').default})
